import React from "react";
import normalizeUpc from "../../../utils/normalizeUpc";

const ProductFilters = ({
    scan_code,
    setScan_code,
    description,
    setDescription,
    department,
    setDepartment,
    pricing_filter,
    setPricing_filter,
    setPage,
}) => {
    return (
        <div className="flex flex-wrap gap-[1vmax]">
            <div className="w-[18%] min-w-[160px] flex items-center border-[0.15vmax] border-gray-300 p-[0.5vmax_0.7vmax] rounded-lg h-fit">
                <span className="text-[1vmax] text-gray-300 inline-block w-[20%]">
                    <i className="fa-solid fa-magnifying-glass"></i>
                </span>
                <input
                    type="text"
                    className="w-[80%] text-[1vmax] font-2 outline-none"
                    placeholder="scan Code ..."
                    value={scan_code}
                    onChange={(e) => { setScan_code(e.target.value); setPage(1); }}
                    onBlur={() => {
                        const normalized = normalizeUpc(scan_code);
                        if (normalized) setScan_code(normalized);
                    }}
                />
            </div>
            <div className="w-[20%] min-w-[180px] flex items-center border-[0.15vmax] border-gray-300 p-[0.5vmax_0.7vmax] rounded-lg h-fit">
                <span className="text-[1vmax] text-gray-300 inline-block w-[20%]">
                    <i className="fa-solid fa-magnifying-glass"></i>
                </span>
                <input
                    type="text"
                    className="w-[80%] text-[1vmax] font-2 outline-none"
                    placeholder="Description ..."
                    value={description}
                    onChange={(e) => { setDescription(e.target.value); setPage(1); }}
                />
            </div>
            <div className="w-[20%] min-w-[180px] flex items-center border-[0.15vmax] border-gray-300 p-[0.5vmax_0.7vmax] rounded-lg h-fit">
                <span className="text-[1vmax] text-gray-300 inline-block w-[20%]">
                    <i className="fa-solid fa-magnifying-glass"></i>
                </span>
                <input
                    type="text"
                    className="w-[80%] text-[1vmax] font-2 outline-none"
                    placeholder="department ..."
                    value={department}
                    onChange={(e) => { setDepartment(e.target.value); setPage(1); }}
                />
            </div>
            <div className="w-[22%] min-w-[220px] flex items-center border-[0.15vmax] border-gray-300 p-[0.5vmax_0.7vmax] rounded-lg h-fit">
                <span className="text-[1vmax] text-gray-300 inline-block w-[12%]">
                    <i className="fa-solid fa-dollar-sign"></i>
                </span>
                <select
                    className="w-[88%] text-[1vmax] font-2 outline-none bg-transparent"
                    value={pricing_filter}
                    onChange={(e) => { setPricing_filter(e.target.value); setPage(1); }}
                >
                    <option value="">All pricing</option>
                    <option value="missing_cost">Missing each cost</option>
                    <option value="missing_retail">Missing each retail</option>
                    <option value="missing_any">Missing cost or retail</option>
                </select>
            </div>
        </div>
    );
};

export default ProductFilters;
